import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const Navbar = props => {
  return (
    <nav className="sub">
      <div className="container-fluid">
        <div className="label">
          <Link to="/" className="normal dark-gray-text">
            <FormattedMessage
              id="regulatory.breadcrumb.title"
              defaultMessage="BD Regulatory"
            />
          </Link>
        </div>
        <ul className="small">
          <li>
            <Link to="/qcinfo">
              <FormattedMessage
                id="qc.title"
                defaultMessage="Quality Certificates"
              />
            </Link>
          </li>
          <li>
            <Link to="/positionstatement">
              <FormattedMessage
                id="pos.title"
                defaultMessage="Position Statements"
              />
            </Link>
          </li>
          <li>
            <Link to="/sdsInfo">
              <FormattedMessage
                id="sds.title"
                defaultMessage="SDS/SVHC/Article Statement"
              />
            </Link>
          </li>
          <li>
            <Link to="/resources">
              <FormattedMessage
                id="resources.title"
                defaultMessage="Resources"
              />
            </Link>
          </li>
          <li>
            <Link to="/faqs">
              <FormattedMessage id="faq.title" defaultMessage="FAQ" />
            </Link>
          </li>
          <li>
            <Link to="/contactus">
              <FormattedMessage
                id="contactus.title"
                defaultMessage="Contact Us"
              />
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
